module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-riben.1eb93a1f.png";